module.exports = __webpack_public_path__ + "img/studydocument.cf8bf9d3.svg";